const reminder = {
  path: 'reminder/:id',
  props: true,
  component: resolve => require(['../../pages/reminder'], resolve)
}

export default reminder
